export const concatenatePaths = (a: string, b: string) => {
	const concatenatedPaths = `${a}/${b}`;
	const pathsWithoutDuplicatedSlashes = concatenatedPaths.replace(/\/\//, "/");
	const pathWithoutEndingSlash = pathsWithoutDuplicatedSlashes.replace(/\/$/, "");
	const pathsWithoutInitialSlash = pathWithoutEndingSlash.replace(/^\//, "");

	return pathsWithoutInitialSlash;
};
